import { makeStyles, Theme } from "@material-ui/core/styles";
import { appBarConstants } from "../../../AppStyles";

const useAppBarStyles = makeStyles((theme: Theme) => ({
	root: {
		flexGrow: 1,
	},
	appBar: {
		background: appBarConstants.backgroundColor,
		color: theme.palette.primary.main,
		height: appBarConstants.height,
	},
	toolbar: {
		padding: 0,
		minHeight: appBarConstants.height,
	},
}));
export default useAppBarStyles;
